import { VimeoEmbed } from "./VimeoEmbed"
import { YoutubeEmbed } from "./YoutubeEmbed"
import "styles/components/videos/videoPlayer.scss"

const VideoEmbed = el => {
  const { videourl } = el.dataset

  const vimeoRegex = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/
  const youtubeRegex = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/gm

  if (vimeoRegex.test(videourl)) {
    VimeoEmbed(el)
  } else if (youtubeRegex.test(videourl)) {
    YoutubeEmbed(el)
  } else {
    // If any of test work maybe it’s a vimeo user url
    if (/(http|https)?:\/\/(www\.)?vimeo.com/.test(videourl)) {
      const {
        embedErrorLabel,
        vimeoEmbedErrorBtnLabel
      } = window.__PAGE_VARS__.translations
      el.insertAdjacentHTML(
        "beforeend",
        `<div class="videoPlayer__embedError-msg">${embedErrorLabel}<br/><a href="${videourl}" target="blank" role="button">${vimeoEmbedErrorBtnLabel}</a></div>`
      )
      el.classList.add("videoPlayer--active")
      el.classList.add("videoPlayer--non-embed")
    }
  }
}

export { VideoEmbed }
